import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { delay: { type: Number, default: 160 } }

  connect() {
    this.timeout = window.setTimeout(() => {
      this.element.classList.add("is-visible")
    }, this.delayValue)
  }

  disconnect() {
    window.clearTimeout(this.timeout)
  }
}
